/* @flow */

import React from 'react';
import EditoRenderer from 'edito/Render';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => {
  return (
    <div>
      <EditoRenderer
        fetchTemplatesUrl="/catalog/flow/templates.json"
        blocks={content.blocks || []}
        locked
      />
    </div>
  );
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/minimal/View.js